

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import MPListingsComponent from '@/components/MPListingsComponent.vue';                       // @ is an alias to /src
import AuctionListingsComponent from '@/components/AuctionListingsComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { TokenUser } from '@/TokenUser'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src

type modeType = 'topshot' | 'auctions'

@Component({
  name: 'Marketplace',
  components: { MPListingsComponent, AuctionListingsComponent, ModalWrapperComponent }
})

export default class Marketplace extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public mode: modeType = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public showAuctionsFAQ() {
    (this.$refs.FAQAuctionsComponent as ModalWrapperComponent).show('Auctions FAQ', 'lg', null)
  }
  // private, non-reactive member variables

  @Watch('mode')
  private async modeChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Marketplace.modeChanged() ${this.mode}`)
    this.$router.replace(utils.recreateURL(`/listings/${this.mode}`, this.$route.query)).catch(() => {})
  }

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Marketplace.pathChanged() ${this.$route.path}`)

    // use mode from URL if it exists
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode as modeType
    } else {
      this.mode = 'topshot'
    }
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    if (this.user) utils_tracker.identify(this.user)

    await this.pathChanged()

    this.$router.replace(utils.recreateURL(`/listings/${this.mode}`, this.$route.query)).catch(() => {})

  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

  }

}
